import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import checkoutTokens from "screens/Settings/MyPlan/Checkout.tokens";

const t = checkoutTokens;

/**
 * Line icons traced from the checkout design so stroke weight and geometry
 * match it exactly. Sizes and stroke widths come from the screen tokens —
 * never inline them here.
 */
interface StrokeIconProps extends SvgIconProps {
  /** Rendered box in px. */
  iconSize: number;
  /** Stroke weight in user units of the 24×24 viewBox. */
  iconStroke: number;
}

const StrokeIcon: React.FC<StrokeIconProps> = ({
  iconSize,
  iconStroke,
  children,
  sx,
  ...rest
}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={iconStroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    sx={{
      width: iconSize,
      height: iconSize,
      flexShrink: 0,
      // SvgIcon's own styles set `fill: currentColor`, which would beat the
      // `fill="none"` attribute and flood these outline glyphs.
      fill: "none",
      ...sx,
    }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

/** Chevron on the "Change" toggle and the country select. */
export const ChevronDownIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.chevron}
    iconStroke={t.size.chevronStroke}
    strokeLinejoin={undefined}
    {...props}
  >
    <path d="M6 9l6 6 6-6" />
  </StrokeIcon>
);

/** Tick marking the selected card in the saved-card picker. */
export const PickerCheckIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.pickerCheck}
    iconStroke={t.size.pickerCheckStroke}
    {...props}
  >
    <path d="M20 6L9 17l-5-5" />
  </StrokeIcon>
);

/** Tick in front of the annual-billing callout. */
export const AnnualCheckIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.annualCheck}
    iconStroke={t.size.annualCheckStroke}
    {...props}
  >
    <path d="M20 6L9 17l-5-5" />
  </StrokeIcon>
);

/** Padlock in the "Encrypted and processed securely by Stripe" footer. */
export const SecureLockIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.lockIcon}
    iconStroke={t.size.lockIconStroke}
    {...props}
  >
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </StrokeIcon>
);

/** Back arrow next to "Back to plans". */
export const CheckoutBackArrowIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    iconSize={t.size.backIcon}
    iconStroke={t.size.backIconStroke}
    {...props}
  >
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </StrokeIcon>
);
